/**
 * Módulos da Werc 2.0 (navegação + Cmd+K). `fase` diz quando cada tela chega
 * (plano: docs/PLANO-WERC-2.0.md). Até lá, o app atual segue atendendo.
 */
export type IdModulo =
  | 'inicio'
  | 'clientes'
  | 'catalogo'
  | 'estoque'
  | 'importacoes'
  | 'futuras'
  | 'vendas'
  | 'pedidos'
  | 'chat'
  | 'docs'
  | 'dashboard'
  | 'config'

export interface Modulo {
  id: IdModulo
  nome: string
  grupo: 'Operação' | 'Comercial' | 'Equipe' | 'Gestão'
  pronto: boolean
  fase?: string
}

export const MODULOS: Modulo[] = [
  { id: 'inicio', nome: 'Início', grupo: 'Operação', pronto: true },
  { id: 'clientes', nome: 'Clientes', grupo: 'Comercial', pronto: true },
  { id: 'pedidos', nome: 'Pedidos', grupo: 'Comercial', pronto: true },
  { id: 'vendas', nome: 'Vendas e propostas', grupo: 'Comercial', pronto: true },
  { id: 'catalogo', nome: 'Catálogo', grupo: 'Operação', pronto: true },
  { id: 'estoque', nome: 'Estoque', grupo: 'Operação', pronto: true },
  { id: 'importacoes', nome: 'Importações', grupo: 'Operação', pronto: true },
  { id: 'futuras', nome: 'Futuras importações', grupo: 'Operação', pronto: true },
  { id: 'chat', nome: 'Chat', grupo: 'Equipe', pronto: true },
  { id: 'docs', nome: 'Docs', grupo: 'Equipe', pronto: true },
  { id: 'dashboard', nome: 'Dashboard', grupo: 'Gestão', pronto: true },
  { id: 'config', nome: 'Configurações', grupo: 'Gestão', pronto: true },
]

export const GRUPOS: Modulo['grupo'][] = ['Operação', 'Comercial', 'Equipe', 'Gestão']
